<template>
    <div class="warehouse-list" v-if="currentComponent">
        <el-card>
            <component
                :is="currentComponent"
                ref="warehouseListComponent"
                :filters="filters"
            />
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'warehouseList',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/main/components/warehouse-list/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
        getWarehouses() {
            this.$refs.warehouseListComponent.getWarehouses();
        }
    }
};
</script>

<style scoped lang="scss">
.warehouse-list {
    margin-top: 16px;
}
</style>
